// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Body-loadingContainer-24FKR {\n  min-height: 50vh;\n}\n", ""]);
// Exports
exports.locals = {
	"loadingContainer": "Body-loadingContainer-24FKR"
};
module.exports = exports;
